import React, { useState } from 'react';
import styles from './ResultPage.module.css';
import CheckList from '../components/CheckList';
import DetalhesCard from '../components/DetalhesCard';
import { gerarRelatorioPDF } from '../utils/pdfGenerator';
import logo from '../assets/logo.png';

export default function ResultPage({ resultado, onVoltar, user, onLogout, bearerToken }) {
  const r = resultado;

  const API_URL = process.env.REACT_APP_API_URL || '';
  // Estados para o modal de email
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailDestino, setEmailDestino] = useState('');
  const [emailEnviando, setEmailEnviando] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null); // 'success' | 'error' | null
  const [emailMensagem, setEmailMensagem] = useState('');

  const handleGerarPDF = () => {
    gerarRelatorioPDF(r, user);
  };

  const abrirModalEmail = () => {
    setEmailDestino(user?.email || '');
    setEmailStatus(null);
    setEmailMensagem('');
    setEmailModalOpen(true);
  };

  const fecharModalEmail = () => {
    if (emailEnviando) return;
    setEmailModalOpen(false);
    setEmailStatus(null);
    setEmailMensagem('');
  };

  const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  function handleBackClick() {
    if (user?.userGuest) {

      window.location.href = '/consulta-avulsa';
    } else {

      onVoltar();
    }
  }
  /* 
    const handleEnviarEmail = async () => {
      if (!validarEmail(emailDestino)) {
        setEmailStatus('error');
        setEmailMensagem('Por favor, insira um email válido.');
        return;
      }
  
      setEmailEnviando(true);
      setEmailStatus(null);
      setEmailMensagem('');
  
      try {
        const response = await fetch(`${API_URL}/api/email`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearerToken}`,
          },
          body: JSON.stringify({
            email: emailDestino,
          }),
        });
  
        const data = await response.json();
  
        if (response.ok) {
          setEmailStatus('success');
          setEmailMensagem('PDF enviado com sucesso! Verifique sua caixa de entrada.');
          setTimeout(() => {
            setEmailModalOpen(false);
            setEmailStatus(null);
            setEmailMensagem('');
          }, 2500);
        } else {
          setEmailStatus('error');
          setEmailMensagem(data.message || 'Erro ao enviar o email. Tente novamente.');
        }
      } catch (error) {
        setEmailStatus('error');
        setEmailMensagem('Erro de conexão. Verifique sua internet e tente novamente.');
      } finally {
        setEmailEnviando(false);
      }
    }; */

  return (
    <div className={styles.page}>

      <header className={styles.header}>
        <div className={styles.logo}>
          <img
            src={logo}
            alt="Analise Central"
            className={styles.logoImage}
          />
        </div>
        {!user?.userGuest && (
          <div className={styles.accountBox}>
            <div className={styles.accountMeta}>
              <strong>{user?.empresa || 'Conta autenticada'}</strong>
              <span className={styles.creditInfo}>{user?.credits ?? 0} créditos</span>
            </div>
            <a href="/recargas" className={styles.btnRecargas}>
              Recargas
            </a>
            <a href="/historico" className={styles.btnRecargas}>
              Historico
            </a>
            <button className={styles.btnLogout} onClick={onLogout} type="button">
              Sair
            </button>
          </div>)}
      </header>

      <main className={styles.main}>

        {/* Botões de ação */}
        <div className={styles.buttonsRow}>
          <button className={styles.btnPdf} onClick={handleGerarPDF}>
            📄 GERAR PDF
          </button>
          {/* <button className={styles.btnEmail} onClick={abrirModalEmail}>
            ✉️ ENVIAR POR EMAIL
          </button> */}
          <button className={styles.btnVoltar2} onClick={handleBackClick}>
            🔄 Nova consulta →
          </button>
        </div>

        {r.tipo == 'PF' ? (
          <div className={styles.pessoaCard}>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Nome</span>
                <span className={styles.fieldVal}>{r.pessoa.nome}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>CPF</span>
                <span className={`${styles.fieldVal} ${styles.mono}`}>{r.pessoa.cpf}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Região do CPF</span>
                <span className={styles.fieldVal}>{r.sintese?.pessoa[0]?.regiao_cpf || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Idade</span>
                <span className={styles.fieldVal}>{r.pessoa.idade} anos</span>
              </div>
            </div>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Nascimento</span>
                <span className={styles.fieldVal}>{r.pessoa.dataNascimento}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Gênero</span>
                <span className={styles.fieldVal}>{r.pessoa.genero || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Mãe</span>
                <span className={styles.fieldVal}>{r.pessoa.mae || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Perfil</span>
                <span className={`${styles.fieldVal} ${styles.mosaic}`}>{r.pessoa.mosaic || '—'}</span>
              </div>
            </div>
          </div>) :
          (<div className={styles.pessoaCard}>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Razão Social</span>
                <span className={styles.fieldVal}>{r.pessoa.razaoSocial}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Fantasia</span>
                <span className={styles.fieldVal}>{r.pessoa.nomeFantasia || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>CNPJ</span>
                <span className={`${styles.fieldVal} ${styles.mono}`}>{r.pessoa.cnpj}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Capital Social</span>
                <span className={styles.fieldVal}>{r.pessoa.capitalSocial || '—'}</span>
              </div>
            </div>
            <div className={styles.pessoaRow}>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Tipo</span>
                <span className={styles.fieldVal}>{r.pessoa.tipoEstabelecimento || '—'}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Natureza Jurídica</span>
                <span className={styles.fieldVal}>{r.pessoa.naturezaJuridica}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Fundação</span>
                <span className={styles.fieldVal}>{r.pessoa.dataFundacao}</span>
              </div>
              <div className={styles.pessoaField}>
                <span className={styles.fieldLabel}>Situação CNPJ</span>
                <span className={styles.fieldVal}>{r.pessoa.situacaoCnpj}</span>
              </div>
            </div>
          </div>)
        }

        <div className={styles.grid2}>
          <CheckList titulo="Pontos de atenção" items={r.alertas} tipo="alerta" />
          <CheckList titulo="Fatores positivos" items={r.positivos} tipo="positivo" />
        </div>

        <DetalhesCard detalhes={r.detalhes} sintese={r.sintese} />

        <div className={styles.footer}>
          <span>Consulta realizada em {r.dataConsulta} · Analise Central v1.0</span>
        </div>
      </main>

      {/* ===== MODAL DE ENVIO DE EMAIL ===== 
      {emailModalOpen && (
        <div className={styles.modalOverlay} onClick={fecharModalEmail}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3>📧 Enviar Relatório por Email</h3>
              <button className={styles.modalClose} onClick={fecharModalEmail} disabled={emailEnviando}>
                ✕
              </button>
            </div>

            <div className={styles.modalBody}>
              <p className={styles.modalDesc}>
                O relatório em PDF será gerado e enviado para o email informado abaixo.
              </p>

              <div className={styles.inputGroup}>
                <label htmlFor="emailDestino">Email de destino</label>
                <input
                  id="emailDestino"
                  type="email"
                  placeholder="exemplo@email.com"
                  value={emailDestino}
                  onChange={(e) => {
                    setEmailDestino(e.target.value);
                    if (emailStatus) setEmailStatus(null);
                  }}
                  disabled={emailEnviando}
                  className={`${styles.emailInput} ${emailStatus === 'error' ? styles.inputError : ''} ${emailStatus === 'success' ? styles.inputSuccess : ''}`}
                  onKeyDown={(e) => e.key === 'Enter' && handleEnviarEmail()}
                />
              </div>

              {emailStatus && (
                <div className={`${styles.statusMessage} ${styles[emailStatus]}`}>
                  {emailStatus === 'success' ? '✅' : '❌'} {emailMensagem}
                </div>
              )}
            </div>

            <div className={styles.modalFooter}>
              <button
                className={styles.btnCancelar}
                onClick={fecharModalEmail}
                disabled={emailEnviando}
              >
                Cancelar
              </button>
              <button
                className={styles.btnEnviar}
                onClick={handleEnviarEmail}
                disabled={emailEnviando || !emailDestino.trim()}
              >
                {emailEnviando ? (
                  <>
                    <span className={styles.spinner}></span>
                    Enviando...
                  </>
                ) : (
                  <>
                    ✉️ Enviar PDF
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}*/}
    </div>
  );
}